import React, { useEffect, useState } from "react";
import TimelineBoard from "../BoardTypes/TimelineBoard";
import WeekBoard from "../BoardTypes/WeekBoard";
import ExpectedValueBoard from "../BoardTypes/ExpectedValueBoard";
import QuantitativeBoard from "../BoardTypes/QuantitativeBoard";
import FrequencyBoard from "../BoardTypes/FrequencyBoard";
import CorrelationBoard from "../BoardTypes/CorrelationBoard";
import WordcloudBoard from "../BoardTypes/WordcloudBoard";
import ClockBoard from "../BoardTypes/ClockBoard";
import { boardTypes } from "../moodboardSettings";
import TableBoard from "../BoardTypes/TableBoard";
import EmptyBoard from "../BoardTypes/EmptyBoard";
import { isBoardVisible } from "../moodboardSettings";
import NetworkBoard from "../BoardTypes/NetworkBoard";
import CompareTimeRanges from "../BoardTypes/CompareTimeRanges";
import OccurrenceBoard from "../BoardTypes/OccurrenceBoard";
import { getLabelId } from "../moodboardModel";

// hover over labels
function initLabelsOpactity(labels) {
  let obj = {};
  labels.map((label) => (obj[label] = 1));
  return obj;
}

export default function CustomCardContent(props) {
  const { variant, rom, moodboard, initialMoodboard } = props;
  const { type, labelProps } = moodboard;
  const [labels, setLabels] = useState([]);
  const [labelOpacity, setLabelOpacity] = useState({}); // opacity of the charts
  useEffect(() => {
    const labels = labelProps.map((prop) => getLabelId(prop));
    setLabels(labels);
    setLabelOpacity(initLabelsOpactity(labels));
  }, [labelProps]);

  // hover over labels
  const handleMouseEnter = (dataKey) => {
    // alle lijnen moeten mindere opactity krijgen
    const opacity = { ...labelOpacity };
    Object.keys(opacity).forEach(function (key) {
      key === dataKey ? (opacity[dataKey] = 1) : (opacity[key] = 0.15);
    });
    setLabelOpacity(opacity);
  };
  const handleMouseLeave = () => {
    const opacity = { ...labelOpacity };
    Object.keys(opacity).forEach(function (key) {
      opacity[key] = 1;
    });
    setLabelOpacity(opacity);
  };

  // select labels from board
  const handleSelectLabels = (labels) => setLabels(labels);

  const quantitativeLabelsChecked = rom.quanti.filter((quantitativeLabel) =>
    labels.includes(quantitativeLabel.id)
  );

  const qualitativeLabelsChecked = rom.quali.filter((qualitativeLabel) =>
    labels.includes(qualitativeLabel.id)
  );

  const openLabelsChecked = rom.openAnswers.filter((qualitativeLabel) =>
    labels.includes(qualitativeLabel.id)
  );

  const choiceLabelsChecked = rom.choiceAnswers.filter((qualitativeLabel) =>
    labels.includes(qualitativeLabel.id)
  );

  const timeLabelsChecked = rom.timeAnswers.filter((timeLabel) =>
    labels.includes(timeLabel.id)
  );

  if (
    !isBoardVisible({
      quantitativeLabelsChecked,
      qualitativeLabelsChecked,
      rom,
      type,
    })
  )
    return <EmptyBoard />;
  switch (type) {
    case boardTypes.timeline:
      return (
        <TimelineBoard
          lineChart={rom.lineChart}
          lineChartWithMissings={rom.lineChartWithMissings}
          table={rom.table}
          data={rom.history}
          quantitativeLabelsChecked={quantitativeLabelsChecked}
          qualitativeLabelsChecked={qualitativeLabelsChecked}
          selectedLabels={labels}
          handleSelectLabels={handleSelectLabels}
          variant={variant}
          labelOpacity={labelOpacity}
          handleMouseEnter={handleMouseEnter}
          handleMouseLeave={handleMouseLeave}
          time={false}
          fullStacked={moodboard.fullStacked}
          smoother={moodboard.smoother}
          initialMoodboard={initialMoodboard}
          connectLine={moodboard.connectLine}
        />
      );

    case boardTypes.week:
      return (
        <WeekBoard
          data={rom.history}
          quantitativeLabelsChecked={quantitativeLabelsChecked}
          table={rom.table}
          selectedLabels={labels}
          labelOpacity={labelOpacity}
          thumbnail={variant === "thumbnail"}
          error={moodboard.errorBars}
          showValues={moodboard.showValues}
          verticalBars={moodboard.verticalBars}
          setLabelOpacity={setLabelOpacity}
          pieChart={moodboard.pieChart}
          sortDec={moodboard.sortDec}
        />
      );

    case boardTypes.expectedValue:
      return (
        <ExpectedValueBoard
          data={rom.history}
          quantitativeLabelsChecked={quantitativeLabelsChecked}
          choiceLabelsChecked={choiceLabelsChecked}
          table={rom.table}
          selectedLabels={labels}
          labelOpacity={labelOpacity}
          setLabelOpacity={setLabelOpacity}
          thumbnail={variant === "thumbnail"}
          error={moodboard.errorBars}
          showValues={moodboard.showValues}
          verticalBars={moodboard.verticalBars}
          pieChart={moodboard.pieChart}
          sortDec={moodboard.sortDec}
        />
      );

    case boardTypes.quantitative:
      return (
        <QuantitativeBoard
          data={rom.history}
          quantitativeLabelsChecked={quantitativeLabelsChecked}
          table={rom.table}
          selectedLabels={labels}
          labelOpacity={labelOpacity}
          thumbnail={variant === "thumbnail"}
          error={moodboard.errorBars}
          showValues={moodboard.showValues}
          verticalBars={moodboard.verticalBars}
          setLabelOpacity={setLabelOpacity}
          pieChart={moodboard.pieChart}
          sortDec={moodboard.sortDec}
        />
      );

    case boardTypes.frequency:
      return (
        <FrequencyBoard
          choiceLabelsChecked={choiceLabelsChecked}
          data={rom.history}
          table={rom.table}
          selectedLabels={labels}
          labelOpacity={labelOpacity}
          thumbnail={variant === "thumbnail"}
          error={moodboard.errorBars}
          showValues={moodboard.showValues}
          verticalBars={moodboard.verticalBars}
          setLabelOpacity={setLabelOpacity}
          pieChart={moodboard.pieChart}
          sortDec={moodboard.sortDec}
        />
      );

    case boardTypes.correlation:
      return (
        <CorrelationBoard
          data={rom.history}
          quantitativeLabelsChecked={quantitativeLabelsChecked}
          table={rom.table}
          selectedLabels={labels}
        />
      );

    case boardTypes.wordcloud:
      return (
        <WordcloudBoard
          data={rom.history}
          table={rom.table}
          selectedLabels={labels}
          openLabelsChecked={openLabelsChecked}
          choiceLabelsChecked={choiceLabelsChecked}
        />
      );

    case boardTypes.clock:
      return (
        <ClockBoard
          data={rom.history}
          timeLabelsChecked={timeLabelsChecked}
          qualitativeLabelsChecked={qualitativeLabelsChecked}
          clockView={moodboard.clockView}
        />
      );

    case boardTypes.table:
      return (
        <TableBoard
          data={rom.verticalTable}
          quantitativeLabelsChecked={quantitativeLabelsChecked}
          qualitativeLabelsChecked={qualitativeLabelsChecked}
          table={rom.table}
          selectedLabels={labels}
          handleSelectLabels={handleSelectLabels}
          variant={variant}
          initialMoodboard={initialMoodboard}
          hideEmptyRows={moodboard.hideEmptyRows}
        />
      );
    case boardTypes.network:
      return (
        <NetworkBoard
          quantitativeLabelsChecked={quantitativeLabelsChecked}
          verticalTable={rom.verticalTable}
          corrMatrix={rom.corrMatrix}
          table={rom.table}
          networkView={moodboard.networkView}
        />
      );
    case boardTypes.compareTimeRanges:
      return (
        <CompareTimeRanges
          data={rom.history}
          quantitativeLabelsChecked={quantitativeLabelsChecked}
          choiceLabelsChecked={choiceLabelsChecked}
          table={rom.table}
          selectedLabels={labels}
          labelOpacity={labelOpacity}
          setLabelOpacity={setLabelOpacity}
          thumbnail={variant === "thumbnail"}
          error={moodboard.errorBars}
          showValues={moodboard.showValues}
          verticalBars={moodboard.verticalBars}
          pieChart={moodboard.pieChart}
          sortDec={moodboard.sortDec}
        />
      );
    case boardTypes.occurrence:
      return (
        <OccurrenceBoard
          choiceLabelsChecked={choiceLabelsChecked}
          data={rom.history}
          table={rom.table}
          occurrences={rom.occurrences}
          selectedLabels={labels}
          labelOpacity={labelOpacity}
          thumbnail={variant === "thumbnail"}
          error={moodboard.errorBars}
          showValues={moodboard.showValues}
          verticalBars={moodboard.verticalBars}
          setLabelOpacity={setLabelOpacity}
          pieChart={moodboard.pieChart}
          sortDec={moodboard.sortDec}
        />
      );
    default:
      return null;
  }
}
